var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-modal",
    {
      attrs: {
        "content-css": {
          minWidth: _vm.getMinWidth,
          maxWidth: _vm.getMaxWidth,
          minHeight: "90vh"
        }
      },
      on: {
        hide: function($event) {
          return _vm.hideModal("no-comment")
        }
      },
      model: {
        value: _vm.show_modal,
        callback: function($$v) {
          _vm.show_modal = $$v
        },
        expression: "show_modal"
      }
    },
    [
      _c(
        "q-modal-layout",
        [
          _c(
            "q-toolbar",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("q-btn", {
                attrs: { flat: "", round: "", dense: "", icon: "fas fa-times" },
                on: {
                  click: function($event) {
                    return _vm.hideModal("no-comment")
                  }
                }
              }),
              _c("q-toolbar-title", [
                _vm._v(
                  "\n                " +
                    _vm._s(
                      !_vm.read_only
                        ? _vm.$t("add_comment")
                        : _vm.$t("comments")
                    ) +
                    " - " +
                    _vm._s(_vm.presential.title) +
                    "\n            "
                )
              ])
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "layout-padding" },
            [
              !_vm.read_only
                ? _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "q-field",
                          {
                            attrs: {
                              helper: _vm.$t("how_do_you_rate_this_training")
                            }
                          },
                          [
                            _c("q-rating", {
                              attrs: {
                                color: "amber",
                                max: 5,
                                icon: "fas fa-star",
                                size: "2rem",
                                disable: _vm.user_disable_comment,
                                error: _vm.$v.user_stars.$error
                              },
                              on: { input: _vm.$v.user_stars.$touch },
                              model: {
                                value: _vm.user_stars,
                                callback: function($$v) {
                                  _vm.user_stars = $$v
                                },
                                expression: "user_stars"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c("q-input", {
                          attrs: {
                            "float-label": _vm.$t("comment"),
                            type: "textarea",
                            "max-height": 100,
                            rows: "3",
                            disable: _vm.user_disable_comment,
                            error: _vm.$v.user_comment.$error
                          },
                          on: { input: _vm.$v.user_comment.$touch },
                          model: {
                            value: _vm.user_comment,
                            callback: function($$v) {
                              _vm.user_comment = $$v
                            },
                            expression: "user_comment"
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-4 q-mt-md" },
                      [
                        _c(
                          "q-btn",
                          {
                            staticClass: "full-width",
                            attrs: {
                              color: "primary",
                              label: _vm.$t("save"),
                              icon: "far fa-save",
                              disable: _vm.user_disable_comment
                            },
                            on: {
                              click: function($event) {
                                return _vm.saveComment()
                              }
                            }
                          },
                          [
                            _vm.user_disable_comment
                              ? _c("q-tooltip", [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.$t(_vm.motive)) +
                                      "\n                        "
                                  )
                                ])
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _vm.comments.length > 0
                ? _c(
                    "q-list",
                    {
                      class: !_vm.read_only ? "q-mt-lg" : "",
                      attrs: { multiline: "", separator: "", "no-border": "" }
                    },
                    [
                      _c("q-list-header", [
                        _vm._v(_vm._s(_vm.$t("recent_comments")))
                      ]),
                      _vm._l(_vm.comments, function(comment, index) {
                        return _c(
                          "q-item",
                          { key: index },
                          [
                            _c(
                              "q-item-main",
                              [
                                _c("q-item-tile", { attrs: { label: "" } }, [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(comment.user_name) +
                                      " "
                                  ),
                                  _c("small", [
                                    _vm._v(
                                      _vm._s(_vm.$t("in")) +
                                        " " +
                                        _vm._s(comment.date)
                                    )
                                  ])
                                ]),
                                _c(
                                  "q-item-tile",
                                  { attrs: { sublabel: "", lines: "2" } },
                                  [
                                    _c(
                                      "p",
                                      [
                                        _c("q-rating", {
                                          attrs: {
                                            color: "amber",
                                            max: 5,
                                            icon: "fas fa-star",
                                            disable: true
                                          },
                                          model: {
                                            value: comment.stars,
                                            callback: function($$v) {
                                              _vm.$set(comment, "stars", $$v)
                                            },
                                            expression: "comment.stars"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(comment.comment) +
                                        "\n                        "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      })
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }